import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { useCompany } from 'hooks/company';
import { usePerson } from 'hooks/person';

import Countdown from 'components/Countdown';

import { generalStatus } from 'utils/handlerStatus';

import './styles.less';

const validStatus = [
  'APPROVED',
  'APROVADO',
  'REPROVED',
  'REPROVADO',
  'PENDING',
  'PENDENTE',
  'PROCESSING',
  'PROCESSANDO',
  'WAITING_DOCUMENTS',
  'AGUARDANDO_DOCUMENTACAO',
];

// const { Countdown } = Statistic;
const I18N_BASE_PATH = 'pages.private.profiles.components.generalStatus.index';

const GeneralStatus = ({ status }) => {
  const { t: translate } = useTranslation();
  const { personId } = useParams();

  const { refreshCompany } = useCompany();
  const { refreshPerson } = usePerson();

  const refreshContent = useCallback(() => {
    if (personId) {
      refreshPerson();
      return;
    }

    refreshCompany();
  }, [personId, refreshCompany, refreshPerson]);

  return (
    <>
      {translate(generalStatus(status)?.value) && (
        <div
          id="general-status-card"
          hidden={!validStatus.includes(status)}
          style={{
            backgroundColor: generalStatus(status)?.color,
          }}
        >
          <div className="general-status-info">
            <i className={`${generalStatus(status)?.icon} general-status-icon`} />
            <div className="general-status-description">
              <strong>{translate(generalStatus(status)?.display)}</strong>
              <span>{translate(generalStatus(status)?.description)}</span>
              {status === 'PROCESSING' && (
                <Countdown
                  prefix={`${I18N_BASE_PATH}.processingCountdown.prefix`}
                  suffix={`${I18N_BASE_PATH}.processingCountdown.suffix`}
                  onFinish={refreshContent}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

GeneralStatus.propTypes = {
  status: PropTypes.string.isRequired,
};

export default GeneralStatus;
